// extracted by mini-css-extract-plugin
export default {"Subheader":"subheader_Subheader__P64R8"};